import { render, staticRenderFns } from "./TaskDetails.vue?vue&type=template&id=7b825423&"
import script from "./TaskDetails.vue?vue&type=script&lang=js&"
export * from "./TaskDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports